import React from 'react'
import { useSelector } from "react-redux";
import {Route,Redirect} from 'react-router-dom'

const PrivateRoute = ({component:Component,...rest}) => {
    const userLogin = useSelector((state) => state.userLogin)
    const { userInfo } = userLogin
    return (
    <Route {...rest} component={(props)=>(userInfo ? (<Component {...props}/>): (<Redirect to='/login'/>) )}/>
    )
}

// Role-based route: only allows access for specified roles
const RoleBasedRoute = ({component:Component, roles, ...rest}) => {
    const userLogin = useSelector((state) => state.userLogin)
    const { userInfo } = userLogin
    
    return (
        <Route {...rest} component={(props) => {
            if (!userInfo) {
                return <Redirect to='/login'/>
            }
            if (roles && !roles.includes(userInfo.role)) {
                return <Redirect to='/'/>
            }
            return <Component {...props}/>
        }}/>
    )
}

export default PrivateRoute
export { RoleBasedRoute }